/**
 * The default server URL to open if no other was specified.
 */
export const DEFAULT_SERVER_URL = 'https://meet.jit.si';
/**
 * 界面主题选项（设置项 themeMode 的合法值）。.
 */
export const THEME_MODES = {
    DARK: 'dark',
    LIGHT: 'light',
    SYSTEM: 'system'
};
